import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "State=Start" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    id: "Background",
    cx: "8",
    cy: "8",
    r: "6",
    stroke: "currentColor",
    "stroke-opacity": "0.1529",
    "stroke-width": "3",
    "stroke-dasharray": "2 2"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }